module.exports = __webpack_public_path__ + "static/media/organized.7c838ac9.png";